var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMetodologica(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 15,
    stroke: "#FF9800",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 8.5L7.875 10.375V11.625L16 9.75L24.125 11.625V10.375L16 8.5ZM12.25 12.25C10.2331 12.25 8.26562 13.0706 8.26562 13.0706L7.875 13.2456V22.875H14.9256C15.1431 23.2487 15.5381 23.5 16 23.5C16.4613 23.5 16.8569 23.2487 17.0744 22.875H24.125V13.2463L23.7344 13.0706C23.7344 13.0706 21.7669 12.25 19.75 12.25C17.9263 12.25 16.325 12.8625 16 12.9925C15.675 12.8625 14.0738 12.25 12.25 12.25ZM12.25 13.5C13.4587 13.5 14.75 13.8906 15.375 14.1056V21.0588C14.6794 20.8294 13.5369 20.5119 12.25 20.5119C10.9362 20.5119 9.86688 20.8144 9.125 21.0588V14.1056C9.60625 13.9313 10.875 13.5 12.25 13.5ZM19.75 13.5C21.125 13.5 22.3938 13.9319 22.875 14.1056V21.0588C22.1325 20.815 21.0638 20.5119 19.75 20.5119C18.4631 20.5119 17.3206 20.8294 16.625 21.0588V14.1056C17.25 13.8906 18.5413 13.5 19.75 13.5Z",
    fill: "#FF9800"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMetodologica);
export default __webpack_public_path__ + "static/media/metodologica.fd84969658d2e7e9a990cde2a7f16198.svg";
export { ForwardRef as ReactComponent };